import React from "react";
import FormField from "./FormField.js";
import { useForm } from "react-hook-form";
import { getTranslations } from './Translations';

import {
  useGoogleReCaptcha
} from 'react-google-recaptcha-v3';

export default function RecrutmentForm({ selectedTender }) {
  let captchaModal = React.useRef(null);
  let token = "";
  const language = window?.HRMRecruitmentComponentConfiguration?.language;
  let translations = getTranslations(language);
  const apiUrl = window.HRMRecruitmentComponentConfiguration?.apiUrl;

  const captchaEnabled = window.HRMRecruitmentComponentConfiguration.captchaSiteKey != null && window.HRMRecruitmentComponentConfiguration.captchaSiteKey != "";

  const { executeRecaptcha } = useGoogleReCaptcha();

  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    shouldUseNativeValidation: true,
    // mode:"all"
  });




  function fileToDataURL(file) {
    var reader = new FileReader()
    return new Promise(function (resolve, reject) {
      reader.onload = function (event) {
        resolve(event.target.result)
      }
      reader.readAsDataURL(file)
    })
  }

  function readAsDataURL(target) {
    // target => <input type="file" id="file">
    var filesArray = Array.prototype.slice.call(target)
    return Promise.all(filesArray.map(fileToDataURL))
  }


  const onSubmit = (values) => {
    disableSubmit();

    if(captchaEnabled)
    {
        executeRecaptcha('form').then(x=>{
          token = x;
          handleFormSubmit(values);
        });
    }
    else
    {
      handleFormSubmit(values);
    }
  };

  function handleFormSubmit(values) {
    var arrFilesBase64 = [];
    let promisesForFiles = [];

    values.Documents = [];
    for (const [key, value] of Object.entries(values)) {
      if (value.constructor.name == "FileList") {

        promisesForFiles.push(
          readAsDataURL(value).then((files) => {

            var index = 0;
            files.forEach(element => {

              arrFilesBase64.push(element.split(',')[1])
              values.Documents.push({ "FileName": value[index].name, "Key": key, "FileContent": element.split(',')[1] });
              index++;
            });
          }));
      }
    };
    if (promisesForFiles.length > 0) {
      Promise.all(promisesForFiles).then(() => {
        sendData(values);
      });
    }
    else
      sendData(values);
  }

  function sendData(values) {
    values["tenderId"] = selectedTender.Tender[0].Id;
    fetch((apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl) + '/ExternalApi/JobApplication', { method: 'POST', body: JSON.stringify(values), headers: { 'Content-Type': 'application/json', 'captcha': token, language: language } })
      .then(res => res.json())
      .then(
        (result) => {
          if(result.Message !== null && (result.Status == "Error_CandidateExists" || result.Status == "Error_TenderNotExistingOrNotActive"))
          {
            openModal(result.Message,closeModalOnError);
          }
          else if (result.Message !== null) {
              alert(result.Message);
          }
          else {
            console.log('OK');
            openModal(translations.successDialogTitle, closeModal);
          }
          enableSubmit();
        },
        (error) => {
          console.log(translations.error + ": " + error);
          alert(error);
          enableSubmit();
        }
      );
  }

  function enableSubmit(){
    let root = document.getElementById('ag-rc-root');
    let submitButton = root.shadowRoot.querySelector("#submitButton");
    submitButton.disabled = false;
    submitButton.classList.remove("button-submit-disable");
  }

  function disableSubmit(){
    let root = document.getElementById('ag-rc-root');
    let submitButton = root.shadowRoot.querySelector("#submitButton");
    submitButton.classList.add("button-submit-disable");
    submitButton.disabled = true;
  }

  function openModal(message,closeAction) {
    let root = document.getElementById('ag-rc-root');
    root.shadowRoot.querySelector('#ModalLongTitle').innerHTML = message;
    root.shadowRoot.querySelector('#modalDialogSuccess_Backdrop').style.display = "block";
    root.shadowRoot.querySelector('#modalDialogSuccess').style.display = "block";
    root.shadowRoot.querySelector('#modalDialogSuccess').classList.add("show");
    root.shadowRoot.querySelector('#buttonCloseModalDialog').onclick = closeAction;
  }
  function closeModal() {
    reset();

    let root = document.getElementById('ag-rc-root');
    root.shadowRoot.querySelector("#modalDialogSuccess_Backdrop").style.display = "none"
    root.shadowRoot.querySelector("#modalDialogSuccess").style.display = "none"
    root.shadowRoot.querySelector("#modalDialogSuccess").classList.remove("show")
  }
  function closeModalOnError() {
    let root = document.getElementById('ag-rc-root');
    root.shadowRoot.querySelector("#modalDialogSuccess_Backdrop").style.display = "none"
    root.shadowRoot.querySelector("#modalDialogSuccess").style.display = "none"
    root.shadowRoot.querySelector("#modalDialogSuccess").classList.remove("show")
  }


  if (selectedTender === null) {
    return (
      <div></div>
    )
  }

  function ErrorSummary({ errors }) {
    if (Object.keys(errors).length === 0) {
      return null;
    }
    return (
      <div className="error-summary">
        {translations?.fillAllTheFields}
      </div>
    );
  }



  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="needs-validation form" id="recruitmentApplication-form">

        <h3 className="tender-form-title">{translations?.applicationForm}</h3>

        {selectedTender?.Form.map((formItem, i) => (
          <FormField formItem={formItem} register={register} errors={errors} />
        ))}

        

        <div>
          <input 
            type="submit" 
            id="submitButton"
            value={translations?.submitButtonText} 
            className="btn btn-secondary" />
          <ErrorSummary errors={errors} />
        </div>
        <br />
       
      </form>

      {/* Modal for successful submit */}
      <div className="modal" id="modalDialogSuccess_Backdrop" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" id="modalDialogSuccess" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="ModalLongTitle"></h4>
              <br /><br />
            </div>             
            <div className="modal-footer">
              <button id="buttonCloseModalDialog" type="button" className="btn btn-secondary" data-dismiss="modal">{translations.close}</button>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}
